<template>
  <div class="hazmat-modal" v-if="hazmat">
    <b-overlay :show="loading" rounded="sm">
      <div class="hazmat-modal__content" :key="key">
        <div class="hazmat-modal__header">
          <div class="hazmat-modal__title">
            <h3>Hazmat Info</h3>
          </div>
          <div class="hazmat-modal__button">
            <button
              @click="$emit('input', hazmat), closeModal()"
              type="button"
              class="close-button"
            >
              <i class="ion ion-close-circle-outline close-button__icon"></i>
            </button>
          </div>
        </div>
        <hr />
        <div class="hazmat__content-inputs-container">
          <div class="hazmat__content__alert-message-title">
            <span class="hazmat__content__alert-message-icon">
              <img
                src="@/assets/scss/icons/triangle-exclamation-solid-full.svg"
                class="hazmat__content__alert-message-icon-image"
                alt="Warning icon"
              />
            </span>
            <strong>Important information</strong>
          </div>
          <div class="hazmat__content__alert-message">
            If your shipment includes more than one different UN number in the same pallet,
            <strong>please contact ltl@goglt.com</strong>.
          </div>
          <RCSelect
            :class="emptyFields['hazmat_number_type'] === true ? 'missing-field' : ''"
            :suggestions="hazmatNumberType"
            :floatLabel="true"
            :label="$t('allOptions.hazmatNumberType')"
            v-model="hazmat.hazmat_number_type"
          />
        </div>
        <div class="hazmat__content-inputs-container">
          <RCInput
            :class="emptyFields['hazmat_number'] === true ? 'missing-field' : ''"
            class="input-container"
            :label="$t('allOptions.hazmatNumber')"
            :type="'number'"
            @input="validateNumberDigits($event)"
            v-model="hazmat.hazmat_number"
          />
          <span v-show="emptyFields.hazmat_number" class="validation">
            *{{ $t("allOptions.validationNumberDigits") }}
          </span>
        </div>
        <div class="hazmat__content-inputs-container">
          <RCSelect
            :class="emptyFields['hazmat_class_division'] === true ? 'missing-field' : ''"
            :suggestions="hazmatClassDivision"
            :floatLabel="true"
            :label="$t('allOptions.hazmatClassDivision')"
            v-model="hazmat.hazmat_class_division"
          />
        </div>
        <div class="hazmat__content-inputs-container">
          <RCSelect
            :class="emptyFields['hazmat_packaging_group'] === true ? 'missing-field' : ''"
            :suggestions="hazmatPackagingGroup"
            :floatLabel="true"
            :label="$t('allOptions.hazmatPackagingGroup')"
            v-model="hazmat.hazmat_packaging_group"
          />
        </div>
        <hr />
        <div class="hazmat__content-inputs-container">
          <div class="warning-header">
            <strong>Contact Hazmat</strong>
          </div>
          <p class="warning-text">Contact information for hazmat materials inquiries.</p>
        </div>
        <div class="hazmat__content-inputs-container">
          <RCInput
            :class="emptyFields['first_name'] === true ? 'missing-field' : ''"
            class="input-container"
            :label="$t('allOptions.hazmatName')"
            :type="'text'"
            v-model="hazmatContact.first_name"
          />
        </div>
        <div class="hazmat__content-inputs-container">
          <RCInput
            :class="emptyFields['last_name'] === true ? 'missing-field' : ''"
            class="input-container"
            :label="$t('allOptions.hazmatLastName')"
            :type="'text'"
            v-model="hazmatContact.last_name"
          />
        </div>
        <div class="contact-form__email-content">
        <RCInput
          class="input-container"
          :class="emptyFields['email'] === true ? 'missing-field' : ''"
          :type="'email'"
          :label="$t('allOptions.hazmatEmail')"
          :floatLabel="true"
          :disabled="isEmailFieldDisabled"
          v-model="hazmatContact.email"
          @input="handleMissingStyles($event, 'email')"
        />
        <span v-show="error.email == true" class="contact-form__validation">
          * {{ $t("createAccount.error.validateEmailAdress") }}
        </span>
    </div>
        <div class="hazmat__content-inputs-container">
          <el-input
            :class="[
              'hazmat-phone-input',
              emptyFields['phone'] === true ? 'missing-field' : '',
            ]"
            v-model="hazmatPhone"
            :placeholder="$t('allOptions.hazmatPhone')"
          />
        </div>
        <button
          @click="saveHazmatInformation()"
          class="button-container"
          :disabled="saving"
        >
          <span v-if="saving" class="spinner-border spinner-border-sm"></span>
          <span v-else v-html="$t('stopsInfo.createStopInfo.save')"></span>
        </button>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ValidateEmptyFields from "@/utils/validateEmptyFields";
import FormatPhoneNumberWithoutPrefix from "@/Extend/FormatPhoneNumberWithoutPrefix";
import RCInput from "../../../../../../components/RCComponents/CustomRCInput.vue";
import RCSelect from "../../../../../../components/RCComponents/CustomRCSelect.vue";

export default {
  name: "HazmatModal",
  mixins: [FormatPhoneNumberWithoutPrefix],
  components: {
    RCSelect,
    RCInput,
  },
  props: {
    hazmatData: Object,
    saving: Boolean,
  },
  data() {
    return {
      loading: false,
      hazmatClassDivision: [],
      hazmatNumberType: [],
      hazmatPackagingGroup: [],
      hazmat: {
        hazmat_class_division: null,
        hazmat_number_type: null,
        hazmat_packaging_group: null,
        hazmat_number: null,
        // hazmat_contact: Aqui va el id quemado
      },
      hazmatContact: {
        first_name: null,
        last_name: null,
        phone: null,
        email: null,
      },
      hazmatContactCopy: {},
      emptyFields: {
        hazmat_class_division: false,
        hazmat_number_type: false,
        hazmat_packaging_group: false,
        hazmat_number: false,
        first_name: false,
        last_name: false,
        phone: false,
        email: false,
      },
      error: {
        email: false,
      },
      editMode: false,
      key: 0,
      hazmatPhone: "",
    };
  },
  computed: {
    isEmailFieldDisabled() {
      return this.compareHazmatContact(
        this.hazmatContact,
        this.hazmatContactCopy
      );
    },
  },
  watch: {
    hazmat() {
      this.editMode = true;
    },
    hazmatPhone: {
      handler() {
        this.formatHazmatPhone();
      },
    },
  },
  async created() {
    this.loading = true;
    if (this.hazmatData) {
      this.hazmat = {
        ...this.hazmat,
        ...this.hazmatData,
      };
    }
    await this.$store.dispatch("load/lineItems/getLineItemPickList");
    // eslint-disable-next-line max-len
    this.hazmatClassDivision = await this.$store.getters["load/lineItems/getLineItemsPicklists"]
      .hazmat_class_division;
    // eslint-disable-next-line max-len
    this.hazmatNumberType = await this.$store.getters["load/lineItems/getLineItemsPicklists"]
      .hazmat_number_type;
    // eslint-disable-next-line max-len
    this.hazmatPackagingGroup = await this.$store.getters["load/lineItems/getLineItemsPicklists"]
      .hazmat_packaging_group;
    const contactId = this.hazmat.hazmat_contact?.id || this.hazmat.hazmat_contact;
    if (contactId) {
      const response = await this.$store.dispatch("load/stops/getSalesforceContactById", contactId);
      if (response) {
        this.hazmatContact = response;
        delete this.hazmatContact.accessorials;
        delete this.hazmatContact.database_id;
        delete this.hazmatContact.last_referenced_date;
        if (this.hazmatContact.phone) {
          this.hazmatPhone = this.hazmatContact.phone;
          this.formatHazmatPhone();
        }
        this.hazmatContactCopy = { ...this.hazmatContact };
      }
    }
    this.loading = false;
    this.key += 1;
  },
  methods: {
    closeModal() {
      if (this.editMode) {
        this.$emit("closeModal", true);
      } else {
        this.$emit("closeModal", false);
      }
    },
    saveHazmatInformation() {
      this.loading = true;
      this.formatHazmatPhone();
      const contactUnchanged = this.compareHazmatContact(
        this.hazmatContact,
        this.hazmatContactCopy
      );
      const validation = this.validateFormfields(contactUnchanged);
      if (!contactUnchanged) {
        const hazmatEmail = this.validateHazmatEmail(this.hazmatContact.email);
        if (!hazmatEmail) {
          this.error.email = true;
          this.emptyFields.email = true;
          this.loading = false;
          return;
        }
      } else {
        this.error.email = false;
      }
      if (validation) {
        this.$emit("saveHazmatInformation", {
          hazmatData: this.hazmat,
          hazmatContact: this.hazmatContact,
          contactHasChanged: !contactUnchanged,
        });
      }
      this.loading = false;
    },
    validateFormfields(contactUnchanged = null) {
      const hazmatFields = {
        hazmat_class_division: this.hazmat.hazmat_class_division,
        hazmat_number_type: this.hazmat.hazmat_number_type,
        hazmat_packaging_group: this.hazmat.hazmat_packaging_group,
        hazmat_number: this.hazmat.hazmat_number,
      };
      const validatedHazmat = ValidateEmptyFields(hazmatFields);
      const isContactUnchanged = contactUnchanged ?? this.compareHazmatContact(
        this.hazmatContact,
        this.hazmatContactCopy
      );
      const validatedContact = isContactUnchanged
        ? { validation: true, emptyFields: [] }
        : ValidateEmptyFields(this.hazmatContact);
      this.resetEmptyFieldsValues();
      const numberDigits = this.validateNumberDigits(this.hazmat.hazmat_number);
      [...validatedHazmat.emptyFields, ...validatedContact.emptyFields].forEach((field) => {
        this.emptyFields[field] = true;
      });
      if (validatedHazmat.validation && validatedContact.validation && numberDigits) {
        this.$emit("input", this.hazmat);
        return true;
      }
      return false;
    },
    compareHazmatContact(currentContact, originalContact) {
      const contactFields = ["first_name", "last_name", "email"];
      let isEqual = true;
      contactFields.forEach((field) => {
        if ((currentContact[field] ?? "") !== (originalContact[field] ?? "")) {
          isEqual = false;
        }
      });
      const currentPhone = this.FormatPhoneNumberWithoutPrefix(currentContact.phone, "USA")
        || currentContact.phone
        || "";
      const originalPhone = this.FormatPhoneNumberWithoutPrefix(originalContact.phone, "USA")
        || originalContact.phone
        || "";
      if (currentPhone !== originalPhone) {
        isEqual = false;
      }
      return isEqual;
    },
    validateNumberDigits(number) {
      let validation = true;
      if (number) {
        if (number.length !== 4) {
          this.emptyFields.hazmat_number = true;
          validation = false;
        } else {
          this.emptyFields.hazmat_number = false;
        }
      }
      return validation;
    },
    formatHazmatPhone() {
      const phone = this.hazmatPhone || this.hazmatContact.phone;
      if (!phone) {
        this.hazmatPhone = "";
        this.hazmatContact.phone = null;
        return;
      }
      const formattedPhoneNumber = this.FormatPhoneNumberWithoutPrefix(phone, "USA");
      if (formattedPhoneNumber) {
        this.hazmatPhone = formattedPhoneNumber;
        this.hazmatContact.phone = formattedPhoneNumber;
      } else {
        this.hazmatContact.phone = phone;
      }
    },
    resetEmptyFieldsValues() {
      const keys = Object.keys(this.emptyFields);
      keys.forEach((key) => {
        this.emptyFields[key] = false;
      });
    },
    handleMissingStyles(value, attribute) {
      if (value) {
        this.emptyFields[attribute] = false;
      } else {
        this.emptyFields[attribute] = true;
      }
    },
    validateHazmatEmail(email) {
      // eslint-disable-next-line max-len
      const regexp = new RegExp(
        /^.*[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\.[a-zA-Z0-9-]+)*$/
      );
      if (regexp.test(email)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../../../../../assets/scss/components/RCComponents.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
@use '@/assets/scss/buttons/_buttons' as *;

.hazmat {
  &-modal {
    padding: 20px;
    &__header {
      @include modals-header;
    }
    &__title {
      @include modals-title;
    }
  }
  &__content {
    &-inputs-container {
      margin: 30px auto;
      .input-container {
        position: relative
      }
    }
    &__alert-message {
      color: $color-primary-company;
      font-size: 0.8rem;
      font-family: $font-family-portal;
      margin-bottom: 30px;
    }
    &__alert-message-title {
      display: flex;
      gap: 10px;
      color: $color-primary-company;
      font-size: 1rem;
      font-family: $font-family-portal;
      margin-bottom: 10px;
    }
    &__alert-message-icon {
      width: 20px;
      height: 20px;
    }
    &__alert-message-icon-image {
      width: 100%;
      height: 100%;
    }
  }
}
.close-button {
  @include modals-close-button();
}
.button-container {
  @include primary-button(35px);
  padding: 4px;
  font-family: $font-family-portal;
}
hr {
  margin-top: 0;
}
.warning-box {
  margin: 20px 0;
  text-align: start;
  font-family: $font-family-portal;
}
.warning-header {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-bottom: 6px;
  color: $color-primary-company;
}
.warning-icon__image {
  width: 15px;
}
.warning-text {
  margin: 0;
  font-size: 12px;
  color: $color-primary-company;
  strong {
    font-weight: 700;
  }
}
.checkbox-container {
  display: flex;
  align-items: center;
  gap: 10px;
  label {
    margin: 0;
    font-family: $font-family-portal;
    color: $color-primary-company;
    font-size: 0.9rem;
  }
}
.hazmat-phone-input {
  width: 100%;
  ::v-deep .el-input__inner {
    border-radius: 10px;
    border: 1px solid $color-border-container;
    height: 40px;
    font-family: $font-family-portal;
    color: $color-primary-company;
  }
}
.missing-field ::v-deep .el-input__inner {
  background: $missing-fields;
}
.validation {
  color: red;
  font-size: 0.8rem;
  position: absolute;
  right: 0px;
}
::v-deep .p-checkbox .p-checkbox-box {
  padding: 10px;
  border-radius: 6px;
  border: 1px solid $color-border-container;
}
::v-deep .p-checkbox .p-checkbox-box.p-highlight {
  background: $color-primary-trigger-button;
  border-color: $color-border-container;
  &:hover {
    background: $color-border-container;
    background-color: $color-border-container;
    border-color: $color-border-container;
  }
}
::v-deep .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {
  border-color: $color-border-container;
  box-shadow: none;
}
::v-deep .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
  border-color: $color-border-container;
}
::v-deep .spinner-border {
  color: $color-primary-company;
}
::v-deep .bg-light {
  background-color: $color-gray-light !important;
}
</style>
